const LocationIcon = ({ className, fill }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.4"
        d="M3.75 18.2093C3.75 9.34891 11.2075 2.08301 20 2.08301C28.7925 2.08301 36.25 9.34891 36.25 18.2093C36.25 22.7317 34.3338 26.534 31.6444 29.6726C28.9654 32.799 25.4758 35.321 22.1974 37.327L22.1786 37.3385L22.1595 37.3494C21.5007 37.7212 20.7566 37.9163 20 37.9163C19.2434 37.9163 18.4993 37.7212 17.8405 37.3494L17.8185 37.337L17.7971 37.3237C14.5306 35.3016 11.0416 32.7876 8.36148 29.6705C5.66978 26.5398 3.75 22.7467 3.75 18.2093Z"
        fill={fill || "#0051FF"}
      />
      <path
        d="M13.3334 18.3337C13.3334 14.6518 16.3181 11.667 20 11.667C23.6819 11.667 26.6667 14.6518 26.6667 18.3337C26.6667 22.0156 23.6819 25.0003 20 25.0003C16.3181 25.0003 13.3334 22.0156 13.3334 18.3337Z"
        fill={fill || "#0051FF"}
      />
    </svg>
  );
};

export default LocationIcon;
